/* Korean won reference amounts for the Korean (/ko) pages.
   Checkout and charging stay in USD. Settings: Theme settings > "Korean won reference (원화 참고 표시)".
   Text comes from the translation keys vvb.krw.approx and vvb.krw.notice (editable in Translate & Adapt). */
(function () {
  var cfg = window.vvbKrw;
  if (!cfg || !cfg.rate) return;

  var RE = /\$\s?(\d{1,3}(?:,\d{3})+|\d+)(\.\d{1,2})?(\s?USD)?/;
  var SKIP = /^(SCRIPT|STYLE|NOSCRIPT|TEXTAREA|INPUT|OPTION|SELECT|TITLE|CODE|PRE)$/;

  function won(usd) {
    var unit = cfg.round || 100;
    return (Math.round((usd * cfg.rate) / unit) * unit).toLocaleString('ko-KR');
  }

  function badge(usd) {
    var s = document.createElement('span');
    s.className = 'vvb-krw';
    s.setAttribute('data-vvb-krw', '1');
    s.textContent = '(' + cfg.fmt.replace('{AMOUNT}', won(usd)) + ')';
    return s;
  }

  function handle(node) {
    var cur = node;
    for (var guard = 0; cur && guard < 12; guard++) {
      var m = RE.exec(cur.nodeValue);
      if (!m) return;
      var nx = cur.nextSibling;
      if (nx && nx.nodeType === 1 && nx.getAttribute('data-vvb-krw')) return;
      var usd = parseFloat((m[1] + (m[2] || '')).replace(/,/g, ''));
      var end = m.index + m[0].length;
      var rest = end < cur.nodeValue.length ? cur.splitText(end) : null;
      if (usd > 0) cur.parentNode.insertBefore(badge(usd), rest);
      cur = rest;
    }
  }

  function scan(root) {
    var list = [];
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        var p = n.parentElement;
        if (!p || SKIP.test(p.tagName)) return NodeFilter.FILTER_REJECT;
        if (!RE.test(n.nodeValue)) return NodeFilter.FILTER_REJECT;
        if (p.closest('.vvb-krw, [data-vvb-nokrw]')) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    while (walker.nextNode()) list.push(walker.currentNode);
    list.forEach(handle);
  }

  function notes() {
    if (!cfg.note) return;
    var buttons = document.querySelectorAll('button[name="checkout"]');
    for (var i = 0; i < buttons.length; i++) {
      var b = buttons[i], prev = b.previousElementSibling;
      if (prev && prev.classList.contains('vvb-krw-note')) continue;
      var p = document.createElement('p');
      p.className = 'vvb-krw-note';
      p.textContent = cfg.note;
      b.parentNode.insertBefore(p, b);
    }
    if (/template--product/.test(document.body.className) && !document.querySelector('main .vvb-krw-note--price')) {
      var w = document.querySelector('main .product-price--wrapper');
      if (w) {
        var q = document.createElement('p');
        q.className = 'vvb-krw-note vvb-krw-note--price';
        q.textContent = cfg.note;
        w.parentNode.insertBefore(q, w.nextSibling);
      }
    }
  }

  function run() {
    try { scan(document.body); notes(); } catch (e) { /* never break the page */ }
  }

  function start() {
    run();
    var timer, obs = new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(function () { run(); obs.takeRecords(); }, 150);
    });
    obs.observe(document.body, { childList: true, subtree: true, characterData: true });
    obs.takeRecords();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
